var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_666_1230)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 10,
    height: 10,
    rx: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 1C6.45898 1 6.90007 1.06022 7.32324 1.18066C7.74642 1.30111 8.14355 1.47038 8.51465 1.68848C8.88574 1.90658 9.22266 2.16862 9.52539 2.47461C9.83138 2.77734 10.0934 3.11426 10.3115 3.48535C10.5296 3.85645 10.6989 4.25358 10.8193 4.67676C10.9398 5.09993 11 5.54102 11 6C11 6.45573 10.9398 6.89681 10.8193 7.32324C10.6989 7.74642 10.5296 8.14355 10.3115 8.51465C10.0934 8.88574 9.83138 9.22428 9.52539 9.53027C9.22266 9.83301 8.88574 10.0934 8.51465 10.3115C8.14355 10.5296 7.74479 10.6989 7.31836 10.8193C6.89518 10.9398 6.45573 11 6 11C5.54427 11 5.10319 10.9398 4.67676 10.8193C4.25358 10.6989 3.85645 10.5296 3.48535 10.3115C3.11426 10.0934 2.77572 9.83301 2.46973 9.53027C2.16699 9.22428 1.90658 8.88574 1.68848 8.51465C1.47038 8.14355 1.30111 7.74642 1.18066 7.32324C1.06022 6.89681 1 6.45573 1 6C1 5.54427 1.06022 5.10482 1.18066 4.68164C1.30111 4.25521 1.47038 3.85645 1.68848 3.48535C1.90658 3.11426 2.16699 2.77734 2.46973 2.47461C2.77572 2.16862 3.11426 1.90658 3.48535 1.68848C3.85645 1.47038 4.25358 1.30111 4.67676 1.18066C5.10319 1.06022 5.54427 1 6 1ZM7.64551 4.55469C7.5153 4.55469 7.40462 4.60026 7.31348 4.69141L5.5459 6.46875L4.91602 5.84375C4.82487 5.7526 4.71582 5.70703 4.58887 5.70703C4.52702 5.70703 4.46842 5.72005 4.41309 5.74609C4.35775 5.77214 4.30729 5.80794 4.26172 5.85352C4.2194 5.89583 4.18522 5.94466 4.15918 6C4.13314 6.05534 4.12012 6.11393 4.12012 6.17578C4.12012 6.30599 4.16569 6.41667 4.25684 6.50781L5.21387 7.46484C5.30501 7.55599 5.41569 7.60156 5.5459 7.60156C5.67611 7.60156 5.78678 7.55599 5.87793 7.46484L7.97754 5.35547C8.06868 5.26432 8.11426 5.15365 8.11426 5.02344C8.11426 4.96159 8.10124 4.90299 8.0752 4.84766C8.04915 4.79232 8.01335 4.74349 7.96777 4.70117C7.92546 4.6556 7.87663 4.61979 7.82129 4.59375C7.76595 4.56771 7.70736 4.55469 7.64551 4.55469Z",
    fill: "#6BB700"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 11,
    height: 11,
    rx: 5.5,
    stroke: "#C8DBF9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_666_1230"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 10,
    height: 10,
    rx: 5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.af2ebda9ebbeb2f5bdbc9b4a1221c0cc.svg";
export { ForwardRef as ReactComponent };